import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";
import SelectControl from "./SelectControl"

import { 
	GetLocal,
	SetLocal,
	FetchService
} from "../Base/BaseControl";

export default function Index(props) {
	const navigate = useNavigate();
	const [getSelectData, setSelectData] = useState([]);
	
    useEffect(() => {			
		ShowFilesReviewAbstractList();
    }, []);		

	const ShowFilesReviewAbstractList =()=> {
		var inputValue = {};
		FetchService("General/Abstract/ShowFilesReviewAbstractList", inputValue, ShowFilesReviewAbstractListSuccess);	
	}
	
	const ShowFilesReviewAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.ReviewInfo)			
	}	
	
	const OnchangeSelectControl =(value)=>{	
		switch(Number(value)) {	
		  case 1:
			navigate("/Employee/Requests/FilingReview?page=تشکیل پرونده");
			break;	
		  case 2:
			navigate("/Employee/Requests/OwnerReview?page=مالکین");
			break;	
		  case 3:
			navigate("/Employee/Requests/ReviewApplication?page=درخواست");
			break;	
		  case 4:
			navigate("/Employee/Requests/ReviewVisitReports?page=گزارش بازدید");
			break;	
		  case 5:
			navigate("/Employee/Requests/ProceedingsReview?page=اقدامات");
			break;	
		  case 6:
			navigate("/Employee/Requests/ReviewDocuments?page=مدارک");
			break;	
		  case 7:
			navigate("/Employee/Requests/ReviewCorrespondence?page=نامه نگاری");
			break;	
		  case 8:
			navigate("/Employee/Requests/DesignReview?page=طرح بر و کف");
			break;	
		  case 9:
			navigate("/Employee/Requests/OrdersReviewMap?page=نقشه");
			break;	
		  case 10:
			navigate("/Employee/Requests/ComplicationsReview?page=پروانه");
			break;	
		  case 11:
			navigate("/Employee/Requests/CertificateEffects?page=گواهی");
			break;	
		  case 12:
			navigate("/Employee/Requests/OffencerView?page=خلاف");
			break;		
		  case 13:
			navigate("/Employee/Requests/ReviewDraftPermit?page=پیش نویس پروانه");
			break;	
		  case 14:
			navigate("/Employee/Requests/DraftReview?page=پیش نویس گواهی");
			break;	
		  case 15:
			navigate("/Employee/Requests/FinancialStatus?page=وضعیت نوسازی");
			break;			
		}
	}	

    return (
		<>
			<div className="alert alert-secondary col col-sm-12 d-flex align-items-baseline">
				<span>بازبینی پرونده: </span>
				<SelectControl
					data={getSelectData}
					className="ms-2"
					onChange={OnchangeSelectControl.bind(getSelectData)}			
				/>	
			</div>
			<hr/>
		</>			
    )
}